<template>
  <div class="InviteCards" :class="store.isSafari ? 'isSafariClass' : ''">
    <div class="card" ref="cardRef">
      <div class="header">花集AI精灵</div>
      <div class="tip">让天下没有难用的AI</div>
      <div class="list">
        <div class="title">文案创作、图片设计、应用模板即可一键生成</div>
        <div class="item">
          <img src="@/assets/bingo.png" alt="" />
          <div class="text">艺术二维码生成</div>
          花束创意设计
        </div>
        <div class="item">
          <img src="@/assets/bingo.png" alt="" />
          <div class="text">婚礼花艺系列</div>
          服装穿搭创意设计
        </div>
        <div class="item">
          <img src="@/assets/bingo.png" alt="" />
          <div class="text">新媒体配图插画</div>
          营销短信写手
        </div>
        <div class="item">
          <img src="@/assets/bingo.png" alt="" />
          <div class="text">小红书爆文写手</div>
          头像生成
        </div>
        <div class="item">
          <img src="@/assets/bingo.png" alt="" />
          <div class="text">电商好评文案写手</div>
          私域消息排版专家
        </div>
        <div class="item">
          <img src="@/assets/bingo.png" alt="" />
          <div class="text">公文笔杆子</div>
          开花店的99个理由
        </div>
        <div class="item">
          <img src="@/assets/bingo.png" alt="" />
          <div class="text">还有更多… …</div>
        </div>
      </div>
      <div class="btttom">
        <div>
          <div class="userName">
            您的好友{{
              store.userInfo.phone
                ? store.userInfo.phone.replace(
                    /(\d{3})\d{4}(\d{4})/,
                    "$1****$2"
                  )
                : ""
            }}
          </div>
          <div class="btttomTip">邀请您注册花集AI精灵</div>
        </div>
        <div class="qrcode">
          <img :src="data.qrcode" alt="" />
        </div>
      </div>
    </div>
    <div class="bottomBtn">
      <div class="title">分享好友</div>
      <div class="itemList">
        <div
          class="item copyBtn"
          @click="data.copyLink"
          :data-clipboard-text="data.inviteUrl"
        >
          <img src="@/assets/copyLInk.png" alt="" />
          <div class="name">复制链接</div>
        </div>
        <div class="item" @click="data.saveImg">
          <img src="@/assets/saveImg.png" alt="" />
          <div class="name">保存海报</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  watchEffect,
  computed,
  defineComponent,
  defineExpose,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { useCounterStore } from "@/store";
import { teamCode } from "@/api/invite";
import { undateImg } from "@/api/img";
import html2canvas from "html2canvas";
import ClipboardJS from "clipboard";
import { showToast } from "vant";
import { showNotify } from "vant";
const QRCode = require("qrcode");
const store = useCounterStore();
/**
 * 路由对象
 */
const route = useRoute();
/**
 * 路由实例
 */
const router = useRouter();
//console.log('1-开始创建组件-setup')
/**
 * 数据部分
 */
const cardRef = ref(null);

const data = reactive({});
data.url = null;
data.inviteUrl = null;
data.sharsUrl = null;
data.qrcode = null;
teamCode().then((res) => {
  if (res.code === 200) {
    if (process.env.NODE_ENV === "production") {
      data.inviteUrl = "https://www.aibene.cn/?invite_code=" + res.data.code;
    } else {
      data.inviteUrl =
        "https://fairy-web-test.aibene.cn/?invite_code=" + res.data.code;
    }
    QRCode.toDataURL(data.inviteUrl).then((res) => {
      data.qrcode = res;
      setTimeout(() => {
        html2canvas(cardRef.value, {
          // scale: 1.5,
          allowTaint: true,
          useCORS: true,
        }).then((canvas) => {
          data.sharsUrl = canvas.toDataURL("image/png");
          undateImg(data.base64ToFile(data.sharsUrl, "newfile.png")).then(
            (resj) => {
              data.url = resj.url;
            }
          );
        });
      });
    });
  }
});

data.base64ToFile = (base64, fileName) => {
  const arr = base64.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], fileName, { type: mime });
};

data.copyLink = () => {
  const clipboard = new ClipboardJS(".copyBtn");
  clipboard.on("success", () => {
    showNotify({ type: "success", message: "复制成功" });
  });
  clipboard.on("error", () => {
    showNotify({ type: "danger", message: "复制失败" });
  });
};

data.saveImg = () => {
  if (data.url) {
    let a = document.createElement("a");
    a.href = data.url;
    a.download = "AI";
    a.click();
  } else {
    showToast("正在生成图片");
  }
};

onBeforeMount(() => {
  //console.log('2.组件挂载页面之前执行----onBeforeMount')
});
onMounted(() => {
  //console.log('3.-组件挂载到页面之后执行-------onMounted')
});
watchEffect(() => {});
// 使用toRefs解构
// let { } = { ...toRefs(data) }
defineExpose({
  ...toRefs(data),
});
</script>
<style lang="scss" scoped>
@font-face {
  font-family: "MyCustomFont"; /* 你给自定义字体起的名字 */
  src: url("@/font/douyu.otf"); /* 字体文件的路径，需要根据实际情况修改 */
}
.InviteCards::-webkit-scrollbar {
  width: 0 !important;
}
.isSafariClass {
  height: calc(100vh - 650px) !important;
}
.InviteCards {
  margin: 0 24px;
  margin-top: 32px;
  height: calc(100vh - 460px);
  overflow: hidden;
  overflow-y: auto;
  .card {
    background: url("@/assets/InviteBackground.png") no-repeat;
    background-size: 100%;
    padding: 32px;
    padding-bottom: 20px;
    .header {
      margin-top: 12px;
      font-family: MyCustomFont, sans-serif;
      color: #8368fc;
      font-size: 64px;
      text-shadow: 0px 2px 4px rgba(255, 255, 255, 0.5);
    }
    .tip {
      color: #333333;
      font-size: 32px;
    }
    .list {
      margin-top: 28px;
      padding: 0 32px;
      padding-bottom: 74px;
      border-radius: 24px;
      border: 2px solid #5c64cd;
      .title {
        padding-top: 32px;
        font-size: 28px;
        font-weight: 500;
        color: #222222;
      }
      .item {
        margin-top: 24px;
        display: flex;
        align-items: center;
        font-weight: 400;
        color: #222222;
        font-size: 28px;
        .text {
          width: 240px;
          margin-left: 12px;
        }
        img {
          width: 32px;
          height: 32px;
        }
      }
      .item:nth-child(2) {
        margin-top: 20px;
      }
    }
    .btttom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: 500;
      color: #222222;
      font-size: 30px;
      padding: 21px 42px;
      margin-top: 32px;
      border-radius: 24px;
      background: #ffffff;
      img {
        width: 110px;
        height: 110px;
      }
    }
  }
  .bottomBtn {
    padding: 24px;
    position: fixed;
    width: calc(100% - 50px);
    left: 0;
    bottom: 0;
    border-radius: 48px 48px 0px 0px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    .title {
      font-size: 34px;
      font-weight: 500;
      color: #ffffff;
    }
    .itemList {
      display: flex;
      color: #f7f5ff;
      font-size: 26px;
      padding: 0 43px;
      padding-top: 24px;
      padding-bottom: 48px;
      .item {
        margin-right: 94px;
        img {
          width: 98px;
          height: 98px;
        }
      }
    }
  }
}
</style>
